// Module
var code = "<script>let $ctrl</script> <molecule-link-with-icon class=\"inline-block ml-2\" click-method=\"$ctrl.refresh()\" inline=\"true\"> <atom-text color=\"white\"> <fa-icon icon=\"sync\"></fa-icon> <span translate=\"TR_140119-a1847d_TR\"></span> </atom-text> </molecule-link-with-icon> ";
// Exports
module.exports = code;